import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { API } from "aws-amplify";

const getSamples = async () =>
  await API.get("mgp", "/samples");

const AddSamplesModal = ({ show, onClickOk, onClickCancel, included }) => {
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [samples, setSamples] = useState(null);
  const handleClickOk = () => {
    onClickOk(selected);
    setSelected([]);
    setOptions([]);
    setSamples(null);
  };
  const handleClickCancel = () => {
    onClickCancel();
    setSelected([]);
    setOptions([]);
    setSamples(null);
  };
  const handleSearch = async (query) => {
    setIsLoading(true);
    var candidates = samples;
    if (!candidates) {
      candidates = await getSamples();
      setSamples(candidates);
    }
    const searchTerm = query.trim();
    const options = candidates
      .filter((sample) => sample?.name?.toLowerCase().includes(searchTerm.toLowerCase()))
      .filter((sample) => !included?.includes(sample.name))
      .map((sample) => sample.name);
    options.sort((a, b) => a.localeCompare(b));
    setOptions(options);
    setIsLoading(false);
  };
  return (
    <Modal
      show={show}
      onHide={handleClickCancel}
      backdrop="static"
    >
      <Modal.Header>
        <Modal.Title>Add samples</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Samples to add into the comparison</Form.Label>
        </Form.Group>
        <AsyncTypeahead
          id="sample-search"
          multiple
          selected={selected}
          options={options}
          onSearch={handleSearch}
          onChange={setSelected}
          placeholder="Search for samples..."
          isLoading={isLoading}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClickCancel}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleClickOk}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddSamplesModal;
